export default __webpack_public_path__ + "static/media/Jain-tour-packages-homepage.ec932ff1.jpg";